var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_c('b-overlay',{attrs:{"show":_vm.show,"rounded":"sm","no-wrap":""},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_vm._t("overlay")]},proxy:true}],null,true)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }